import React, { useState } from "react";
import "./style.css";

const PopupUI = ({ notifications, setNotifications, setNotifyCount }) => {
  const [isClearing, setIsClearing] = useState(false);

  const handleReadAll = () => {
    if (isClearing || notifications.length === 0) return;
    setIsClearing(true);

    notifications.forEach((_, i) => {
      setTimeout(() => {
        setNotifications((prev) => prev.slice(1));
        setNotifyCount((prevCount) => Math.max(prevCount - 1, 0));
      }, i * 150);
    });

    setTimeout(() => setIsClearing(false), notifications.length * 150 + 600);
  };
  
  return (
    <div
      className="position-absolute bg-light rounded-5 shadow-lg"
      style={{
        width: 350,
        height: 500,
        right: -102,
        top: 50,
        border: "solid 1px rgba(48, 33, 88, 0.3)",
        zIndex: 1000,
        overflow: "hidden",
      }}
    >
      <div className="position-relative h-100 d-flex flex-column">
        {/* Header */}
        <div
          className="d-flex justify-content-center align-items-center text-white rounded-top-5 py-2"
          style={{ background: "#302154", height: 60 }}
        >
          <h5 className="m-0">Notifications</h5>
        </div>

        {/* Notification List */}
        <div
          className={`py-2 pt-3 scrollbar-notify flex-grow-1 w-100 ${
            notifications.length === 0 ? "pb-4" : "ps-3 pe-3"
          }`}
          style={{ position: "relative", height: 390 }}
        >
          {notifications.length === 0 ? (
            <div
              className="h-100 d-flex justify-content-center align-items-center fade-in"
              style={{ marginTop: -18 }}
            >
              <div className="text-center py-5">
                <i className="bi bi-envelope-open fs-3 text-secondary"></i>
                <p className="m-0 text-secondary">All caught up!</p>
              </div>
            </div>
          ) : (
            notifications.map((notification, index) => (
              <div
                key={notification.id || index}
                className={`rounded-4 mb-2 shadow-sm bg-white p-3 border notification-card
                  ${isClearing ? "slide-right" : ""}
                  ${notification.isNew ? "notification-pop" : ""}
                `}
                style={{
                  animationDelay: isClearing ? `${index * 0.1}s` : "0s",
                }}
              >
                <span className="text-muted" style={{ fontSize: "12px" }}>
                  {new Date(notification.timestamp).toLocaleString()}
                </span>{" "}
                &nbsp;
                <span
                  className={`badge text-uppercase ${
                    notification.level === "error"
                      ? "bg-danger text-white"
                      : notification.level === "warn"
                      ? "bg-warning text-dark"
                      : notification.level === "info"
                      ? "bg-success text-white"
                      : notification.level === "login"
                      ? "bg-info text-dark"
                      : notification.level === "event"
                      ? "bg-primary text-white"
                      : notification.level === "alert"
                      ? "bg-magenta text-white"
                      : notification.level === "notify"
                      ? "bg-light text-dark border"
                      : notification.level === "debug"
                      ? "bg-secondary text-white"
                      : "bg-dark text-white"
                  }`}
                  style={{
                    fontSize: "10px",
                    letterSpacing: "0.3px",
                    borderRadius: "6px",
                    padding: "3px 6px",
                  }}
                >
                  {notification.level}
                </span>
                <div className="pt-1">{notification.message}</div>
              </div>
            ))
          )}
        </div>

        {/* Footer */}
        {/* {notifications.length > 0 && (
          <div className="text-center py-2 pb-4">
            <div
              className={`text-decoration-underline ${
                isClearing ? "text-muted" : "text-primary"
              }`}
              onClick={handleReadAll}
              style={{
                cursor: isClearing ? "not-allowed" : "pointer",
                transition: "opacity 0.3s ease",
              }}
            >
              {isClearing ? "Clearing..." : "Mark all as read"}
            </div>
          </div>
        )} */}
      </div>
    </div>
  );
};

export default PopupUI;